import getTranslationOptions from 'owa-translation/lib/utils/getTranslationOptions';
import { TranslationOptions } from 'owa-outlook-service-options';
import { mutatorAction } from 'satcheljs';
import { lazyUpdateTranslationOptions } from 'owa-translation';

export default mutatorAction('setTranslationMode', function setTranslationMode(mode: number) {
    const userOptions: TranslationOptions = getTranslationOptions();

    // Need to track the original options to log differences
    const originalOptions: TranslationOptions = {
        feature: userOptions.feature,
        targetLanguage: userOptions.targetLanguage,
        translationMode: userOptions.translationMode,
        excludedLanguages: [...userOptions.excludedLanguages],
    };

    userOptions.translationMode = mode;

    lazyUpdateTranslationOptions.import().then(updateTranslationOptions => {
        updateTranslationOptions(originalOptions, userOptions);
    });
});
